import React from 'react'
import logo from 'assets/images/logo.png';

const Logo = () => {
  return <img src={logo} alt="Logo" className="w-[100px] sm:w-[200px] lg:w-[200px] h-[100px]" style={{
    height:"auto"
  }}/>
}

export default Logo